export class DataSourceItems {
    dataSourceName: string;
    dataSourceItems: any[];
}